export default __webpack_public_path__ + "static/bretonnia-6da87bb9a5789ab01301e9ea41a95f37.webp";